/* HU proof-fee fix 10/22: keeps the "Emailed Digital Mock-Up" add-on at 1 per cover line (per design).
   - A mock-up line tagged with _proof_id stays at quantity 1 while a cover line with the same _proof_id is in the cart,
     and is removed when that cover is removed.
   - Untagged (older) mock-up lines are set to the number of cover lines that say "Mock-Up: Yes" and have no tagged mock-up.
   Runs on load and after every cart update (cart page and cart drawer). */
(function () {
  if (window.__huAddonSync) return; window.__huAddonSync = true;
  var script = document.currentScript;
  var MOCKUP_IDS = String((script && script.dataset.mockupVariants) || '50702582219025').split(',').map(function (x) { return Number(x.trim()); }).filter(Boolean);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, again = false;
  var isMockup = function (it) { return MOCKUP_IDS.indexOf(Number(it.variant_id)) !== -1 || (it.properties && it.properties._hu_addon === 'mockup'); };
  var wantsMockup = function (it) {
    var p = it.properties || {};
    return Object.keys(p).some(function (k) { return /mock-?up/i.test(k) && /^yes/i.test(String(p[k] || '')); });
  };
  function plan(cart) {
    var items = cart.items || [], covers = items.filter(function (it) { return !isMockup(it); });
    var coverIds = {}; covers.forEach(function (c) { var id = c.properties && c.properties._proof_id; if (id) coverIds[id] = true; });
    var tagged = {}, updates = {}, changed = false, legacy = [];
    items.filter(isMockup).forEach(function (m) {
      var id = m.properties && m.properties._proof_id;
      if (!id) { legacy.push(m); return; }
      var want = coverIds[id] && !tagged[id] ? 1 : 0;   /* also drops duplicate mock-ups for the same design */
      if (want) tagged[id] = true;
      if (m.quantity !== want) { updates[m.key] = want; changed = true; }
    });
    var legacyWant = covers.filter(function (c) { var id = c.properties && c.properties._proof_id; return wantsMockup(c) && !(id && tagged[id]); }).length;
    legacy.forEach(function (m, i) {
      var want = i === 0 ? legacyWant : 0;
      if (m.quantity !== want) { updates[m.key] = want; changed = true; }
    });
    return changed ? updates : null;
  }
  function refresh() {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hu-addon-sync' }); return; }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }
  function run() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = plan(cart);
      if (!updates) return null;
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.json(); }).then(refresh);
    }).catch(function () { /* best effort; checkout still shows the real lines */ }).then(function () {
      busy = false; if (again) { again = false; run(); }
    });
  }
  window.huAddonSync = { run: run, plan: plan };
  var hook = function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'hu-addon-sync') run(); });
    run();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
})();
